// src/helpers/stringUtils.js
import moment from 'moment'
import { i18n } from '@/plugins/i18n'

const { t } = i18n.global

export function getExpiryDate(activatedDate) {
  if (activatedDate) {
    return moment(activatedDate).add(1, 'year').format(t('dates.expiryFormat'))
  }
  return t('common.never')
}

export function uppercase(word) {
  return word !== undefined ? word.toUpperCase() : ''
}

export function capitalize(str) {
  if (!str) return ''
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

// export function interpret(word) {
//   const mapping = {
//     greenYear: 'The Green Year',
//     redYear: 'The Red Year',
//     blueYear: 'The Blue Year',
//   }
//   return mapping[word] || word
// }
export function interpret(word, language = null) {
  // If a specific language is provided, use that language's translation
  // Otherwise use current UI locale (for backward compatibility)
  const key = `years.${word}`

  if (language) {
    const messages = i18n.global.messages.value?.[language]
    if (messages && messages.years && messages.years[word]) {
      return messages.years[word]
    }
  }

  // Fall back to current locale translation
  const translated = t(key)
  return translated === key ? word : translated
}

export function shortHand(name) {
  if (!name || typeof name !== 'string' || !name.trim()) return 'NN'

  const words = name.trim().split(/\s+/)
  return words.length === 1
    ? words[0][0].toUpperCase()
    : (words[0][0] + words[words.length - 1][0]).toUpperCase()
}

/** Normalize any date-ish input to 'YYYY-MM-DD' (no time). */
export function toYMD(input) {
  if (!input) return ''
  const m = moment(input)
  return m.isValid()
    ? m.format('YYYY-MM-DD')
    : new Date(input).toISOString().slice(0, 10)
}

/** Pretty date for display without time, localized. */
export function prettyDate(input) {
  if (!input) return ''
  const m = moment(input)
  return m.isValid()
    ? m.format(t('dates.prettyFormat'))
    : new Date(input).toDateString()
}
